import React from 'react';
import { FormTextField } from '@uncinc/uncinc-react-kitchen-sink';

const TextField = ({ onChange, ...props }) => {
  let t = null;

  const _onChange = (value) => {
    if (t) {
      clearTimeout(t);
    }

    t = setTimeout(() => {
      onChange(value);
    }, 500);
  };

  return (
    <FormTextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      handleChange={() => { }}
      onChange={(e) => _onChange(e.target.value)}
    />
  );
};
export default TextField;
